import {
  FilterMode,
  AlertSubscriptionCreateMutationVariables,
  AlertSubscription_OrderBy,
  AlertSubscription,
  SortOrder,
  AlertSubscription_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const alertSubscriptionService = {
  createOne: buildCreateOne(
    (
        alertSubscriptionCreateVariables: AlertSubscriptionCreateMutationVariables
      ) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.alertSubscriptionCreate(
          alertSubscriptionCreateVariables
        );
        return result.alertSubscriptionCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.alertSubscriptionOne({ id });
    return result.alertSubscriptionOne as AlertSubscription;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: AlertSubscription_OrderBy[] | null = null,
    filter: AlertSubscription_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: AlertSubscription_Filter | undefined;
    if (searchValue !== "") {
      where = { id: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.alertSubscriptionListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : { id: SortOrder.Asc },
      where,
    });
    const list = nullToUndefinedRecursive(
      result.alertSubscriptionListWithOffset
    ) as AlertSubscription[];
    return { list, orderBy };
  },
};
